@if (!item) {
  <div class="empty-state">
    @if (section() === 'folders') {
      <app-no-content-stub imageSrc="assets/placeholders/placeholder-files.svg" [size]="124">
        <p class="text-base font-medium text-gray-900 text-center">No folder selected</p>
        <app-button2 class="[&>button]:bg-offwhite" appearance="secondary" size="m" [gap]="4" (click)="handleNewFolder()">
          <app-icon name="folder-nested" />
          Create a new folder
        </app-button2>
      </app-no-content-stub>
    } @else {
      <app-no-content-stub imageSrc="assets/placeholders/placeholder-files.svg" [size]="124">
        <p class="text-base font-medium text-gray-900 text-center">No file selected</p>
        <app-button2 class="[&>button]:bg-offwhite" appearance="secondary" size="m" [gap]="4" (click)="handleNewFile()">
          <app-icon name="upload" />
          Upload a new file
        </app-button2>
      </app-no-content-stub>
    }
  </div>
}

@if (item) {
  @switch (item | stitchType) {
    @case (StitchType.FILE) {
      <app-file-form
        [file]="asFile(item)"
        (close)="handleFormClose($event)"
        />
    }
    @case (StitchType.FOLDER) {
      <app-folder-form
        id="folder-form"
        [folder]="asFolder(item)"
        (close)="handleFormClose($event)"
        />
    }
  }
}
